import { render, staticRenderFns } from "./PersonProfileMasterPersonDetails.vue?vue&type=template&id=1270ed38&scoped=true&"
import script from "./PersonProfileMasterPersonDetails.vue?vue&type=script&lang=js&"
export * from "./PersonProfileMasterPersonDetails.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileMasterPersonDetails.vue?vue&type=style&index=0&id=1270ed38&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1270ed38",
  null
  
)

export default component.exports